import { AtBuildingBartRow } from '../measurement/facilitiesSchemaUtilsUniversal';

export const BART_LEASE_TYPE_LABELS: Record<
  NonNullable<AtBuildingBartRow['building_lease_type']>,
  string
> = {
  coworking_or_serviced_office: 'Coworking or serviced office',
  upstream_lease: 'Leased',
  upstream_sublease: 'Upstream sublease',
  owned: 'Owned',
  downstream_lease_customer_paying_utilities:
    'Downstream lease, paying utilities',
  downstream_lease_customer_not_paying_utilities:
    'Downstream lease, not paying utilities',
  downstream_sublease_customer_not_paying_utilities:
    'Downstream sublease, not paying utilities',
  downstream_sublease_customer_paying_utilities:
    'Downstream sublease, paying utilities',
  franchise: 'Franchise',
  sold_building: 'Sold building',
} as const;
